<script setup lang="ts">

</script>

<template>
  <div>Project View v2 is here!</div>
</template>
